// Full brand deck - all slides
export { BrandSlides as default } from "../../sections/BrandSlides";
